import React from 'react'
import styles from './GuestNameFeild.module.scss'
import { FormLabel } from '../../../../elements/form-label'
import { Controller, useFormContext } from 'react-hook-form';
import { GuestEventFormType } from '../../useGuestEvent';
import classNames from 'classnames';

export function GuestNameFeild(props: {hasName: boolean}) {
  const {control, formState:{errors}} = useFormContext<GuestEventFormType>()
  if(props.hasName) return null;
  return (
    <Controller
        name="guestName"
        control={control}
        rules={{ required: 'Guest name is required' }}
        render={({ field }) => (
          <div className={styles.container}>
            <FormLabel>Name</FormLabel>
            <input className={classNames(styles.input, {
              [styles.inputError]: !!errors.guestName
            })} {...field}placeholder='Enter your name' />
            {!!errors.guestName ? <span>{errors.guestName.message}</span>:null}
          </div>
        )}
      />
    
  )
}
